<template>
    <div style="padding: 20px;">
        <el-button type="primary" @click="handleAddTag" style="margin-bottom: 20px;">新增标签</el-button>

        <el-tree
            ref="tagTree"
            :data="tagTreeData"
            :props="{ label: 'name', children: 'children' }"
            node-key="id"
            default-expand-all
            :expand-on-click-node="false"
            style="border: 1px solid #ebeef5; padding: 10px; border-radius: 4px;"
        >
            <template #default="{ node, data }">
                <div class="tag-tree-node">
                    <!-- 左侧：名称、隐藏标签、描述、icon（跟随树形缩进） -->
                    <div class="tag-info-left">
                        <span class="tag-name highlight-text">{{ node.label }}</span>
                        <!-- 新增：icon展示 -->
                        <template v-if="data.icon">
                            <img :src="VUE_APP_CDN_URL + data.icon" class="tag-icon" alt="标签图标" />
                        </template>
                        <el-tag v-if="data.hide" size="mini" type="danger" style="margin-left: 8px;">隐藏</el-tag>
                        <span class="tag-desc" v-if="data.detail">描述：{{ data.detail }}</span>
                    </div>
                    <!-- 右侧：排序、创建、修改、操作（整体靠右） -->
                    <div class="tag-info-right">
                        <span class="tag-prop">排序：{{ data.ranking || 99 }}</span>
                        <span class="tag-prop" v-if="data.createDt">创建：{{ formatDateTime(data.createDt) }}</span>
                        <span class="tag-prop" v-if="data.updateDt">修改：{{ formatDateTime(data.updateDt) }}</span>
                        <div class="tag-actions">
                            <el-button size="mini" type="text" @click.stop="handleEditTag(data)">编辑</el-button>
                            <el-button
                                size="mini"
                                type="text"
                                :style="{ color: data.hide ? '#67c23a' : '#f56c6c' }"
                                @click.stop="handleToggleHide(data)"
                            >
                                {{ data.hide ? '显示' : '隐藏' }}
                            </el-button>
                            <el-button size="mini" type="text" style="color: #f56c6c;" @click.stop="handleDeleteTag(data.id)">删除</el-button>
                        </div>
                    </div>
                </div>
            </template>
        </el-tree>

        <el-dialog
            title="标签管理"
            width="600px"
            :visible.sync="dialogVisible"
            destroy-on-close
            :close-on-click-modal="false"
        >
            <el-form :model="tagForm" label-width="80px">
                <el-form-item label="标签名称" required>
                    <el-input
                        v-model="tagForm.name"
                        placeholder="请输入标签名称"
                        maxlength="50"
                        show-word-limit
                    />
                </el-form-item>

                <el-form-item label="父标签">
                    <el-select
                        v-model="displayParentName"
                        placeholder="请选择父标签（无则不选）"
                        clearable
                        style="width: 100%;"
                        @clear="handleClearParent"
                        @visible-change="handleSelectVisibleChange"
                        filterable
                        :filter-method="() => false"
                    >
                        <el-option
                            value=""
                            style="height: auto; padding: 0;"
                        >
                            <el-tree
                                ref="selectTree"
                                :data="tagTreeData"
                                :props="{ label: 'name', children: 'children' }"
                                node-key="id"
                                highlight-current
                                :default-expanded-keys="expandedKeys"
                                @node-click="handleNodeClick"
                                style="max-height: 300px; overflow-y: auto; width: 100%;"
                            />
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="排序值">
                    <el-input-number
                        v-model="tagForm.ranking"
                        :min="0"
                        :max="999"
                        controls-position="right"
                    />
                </el-form-item>

                <el-form-item label="是否隐藏">
                    <el-switch
                        v-model="tagForm.hide"
                        active-color="#f56c6c"
                        inactive-color="#67c23a"
                        active-text="隐藏"
                        inactive-text="显示"
                    />
                </el-form-item>

                <el-form-item label="标签描述">
                    <el-input
                        v-model="tagForm.detail"
                        type="textarea"
                        rows="3"
                        placeholder="请输入标签描述（选填）"
                    />
                </el-form-item>

                <!-- 新增：icon上传表单项 -->
                <el-form-item label="icon:">
                    <el-upload
                        :headers="headers"
                        class="avatar-uploader"
                        :action="uploadURL"
                        :show-file-list="false"
                        :on-success="handleIconSuccess"
                        :before-upload="beforeIconUpload"
                    >
                        <!-- 扩大点击区域的容器 -->
                        <div class="upload-box">
                            <img v-if="tagForm.icon" :src="VUE_APP_CDN_URL + tagForm.icon" class="upload-img" alt=""/>
                            <div v-else class="upload-placeholder">
                                <i class="el-icon-plus"></i>
                                <span>点击上传图标</span>
                            </div>
                        </div>
                    </el-upload>
                </el-form-item>
            </el-form>

            <div slot="footer">
                <el-button @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" @click="handleSaveTag">保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { getTagTree, saveTag, getTagById, deleteTag } from "@/http/womensApi";

export default {
    name: "TagsList",
    data() {
        return {
            dialogVisible: false,
            tagTreeData: [],
            displayParentName: "",
            expandedKeys: [],
            // 新增：上传相关配置
            uploadURL: process.env.VUE_APP_BASE_URL + "game/upload",
            VUE_APP_BASE_URL: null,
            VUE_APP_CDN_URL: null,
            headers: { Authorization: this.$store.state.user.token },
            tagForm: {
                id: null,
                name: "",
                pid: "",
                ranking: 99,
                hide: false,
                detail: "",
                // 新增：icon字段
                icon: ""
            }
        };
    },
    mounted() {
        this.loadTagTree();
        // 初始化CDN和BASE URL
        this.VUE_APP_BASE_URL = process.env.VUE_APP_BASE_URL;
        this.VUE_APP_CDN_URL = process.env.VUE_APP_CDN_URL;
    },
    methods: {
        formatDateTime(timeStr) {
            if (!timeStr) return "";
            try {
                const date = new Date(timeStr);
                const padZero = num => num.toString().padStart(2, '0');

                const year = date.getFullYear();
                const month = padZero(date.getMonth() + 1);
                const day = padZero(date.getDate());
                const hour = padZero(date.getHours());
                const minute = padZero(date.getMinutes());
                const second = padZero(date.getSeconds());

                return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
            } catch (err) {
                return timeStr;
            }
        },

        loadTagTree() {
            getTagTree().then(resp => {
                if (resp?.data?.status === 0) {
                    this.tagTreeData = resp.data.info || [];
                    this.formatHideField(this.tagTreeData);
                }
            }).catch(err => {
                this.$message.error("加载标签失败：" + err.message);
            });
        },

        formatHideField(nodes) {
            nodes.forEach(node => {
                node.hide = node.hide === 1 || node.hide === true;
                if (node.children && node.children.length > 0) {
                    this.formatHideField(node.children);
                }
            });
        },

        handleAddTag() {
            this.tagForm = {
                id: null,
                name: "",
                pid: "",
                ranking: 99,
                hide: false,
                detail: "",
                // 新增：清空icon
                icon: ""
            };
            this.displayParentName = "";
            this.expandedKeys = [];
            this.dialogVisible = true;
        },

        handleEditTag(data) {
            getTagById(data.id).then(resp => {
                if (resp?.data?.status === 0) {
                    const tag = resp.data.info;
                    this.tagForm = {
                        id: tag.id,
                        name: tag.name || "",
                        pid: tag.pid ? tag.pid + "" : "",
                        ranking: tag.ranking || 99,
                        hide: tag.hide === 1 || tag.hide === true,
                        detail: tag.detail || "",
                        // 新增：赋值icon
                        icon: tag.icon || ""
                    };

                    if (this.tagForm.pid) {
                        this.displayParentName = this.getCascadeNameById(this.tagTreeData, this.tagForm.pid);
                        this.expandedKeys = this.getParentKeys(this.tagTreeData, this.tagForm.pid, []);
                    } else {
                        this.displayParentName = "";
                        this.expandedKeys = [];
                    }

                    this.dialogVisible = true;
                }
            }).catch(err => {
                this.$message.error("获取标签信息失败：" + err.message);
            });
        },

        handleToggleHide(data) {
            const newHideStatus = !data.hide;
            const params = {
                id: data.id,
                name: data.name,
                pid: data.pid || 0,
                ranking: data.ranking || 99,
                hide: newHideStatus ? 1 : 0,
                detail: data.detail || "",
                // 新增：保留icon字段
                icon: data.icon || ""
            };

            saveTag(params).then(resp => {
                if (resp?.data?.status === 0) {
                    this.$message.success(newHideStatus ? "标签已隐藏" : "标签已显示");
                    data.hide = newHideStatus;
                } else {
                    this.$message.error("操作失败：" + (resp?.data?.msg || "接口异常"));
                }
            }).catch(err => {
                this.$message.error("操作失败：" + err.message);
            });
        },

        handleNodeClick(nodeData) {
            this.displayParentName = this.getCascadeNameByNode(nodeData);
            this.tagForm.pid = nodeData.id + "";
            this.$refs.selectTree.setCurrentKey(nodeData.id);

            const event = new Event('click', { bubbles: true });
            document.querySelector('.el-select').dispatchEvent(event);
        },

        getCascadeNameByNode(node) {
            const names = [];
            let currentNode = node;

            while (currentNode) {
                names.unshift(currentNode.name);
                currentNode = currentNode.parent;
            }

            return names.join('/');
        },

        getCascadeNameById(nodes, targetId, parentNames = []) {
            for (const node of nodes) {
                if (node.id + "" === targetId) {
                    return [...parentNames, node.name].join('/');
                }
                if (node.children) {
                    const res = this.getCascadeNameById(node.children, targetId, [...parentNames, node.name]);
                    if (res) return res;
                }
            }
            return "";
        },

        handleClearParent() {
            this.displayParentName = "";
            this.tagForm.pid = "";
        },

        handleSelectVisibleChange(visible) {
            if (visible && this.tagForm.pid) {
                this.$nextTick(() => {
                    const tree = this.$refs.selectTree;
                    if (tree) {
                        tree.setCurrentKey(this.tagForm.pid);
                    }
                });
            }
        },

        getParentKeys(nodes, targetId, keys) {
            for (let i = 0; i < nodes.length; i++) {
                const node = nodes[i];
                if (node.id + "" === targetId) {
                    return keys;
                }
                if (node.children) {
                    const temp = [...keys, node.id + ""];
                    const res = this.getParentKeys(node.children, targetId, temp);
                    if (res) {
                        return res;
                    }
                }
            }
            return [];
        },

        // 新增：icon上传成功回调
        handleIconSuccess(data) {
            this.tagForm.icon = data.info;
        },

        // 新增：icon上传前校验
        beforeIconUpload(data) {
            const suffix = data.name.substring(data.name.lastIndexOf('.')).toLowerCase();
            const type = ['.png', '.jpg', '.jpeg'].includes(suffix);
            if (!type) {
                this.$message.error('上传图片只能是png/jpg/jpeg格式!');
            }
            return type;
        },

        handleSaveTag() {
            if (!this.tagForm.name.trim()) {
                this.$message.warning("标签名称不能为空！");
                return;
            }
            const params = {
                ...this.tagForm,
                pid: this.tagForm.pid || 0,
                hide: this.tagForm.hide ? 1 : 0
            };
            saveTag(params).then(resp => {
                if (resp?.data?.status === 0) {
                    this.$message.success(this.tagForm.id ? "编辑成功" : "新增成功");
                    this.dialogVisible = false;
                    this.loadTagTree();
                } else {
                    this.$message.error("保存失败：" + (resp?.data?.msg || "接口异常"));
                }
            }).catch(err => {
                this.$message.error("保存失败：" + err.message);
            });
        },

        handleDeleteTag(id) {
            this.$confirm("确定删除该标签吗？删除后不可恢复！", "警告", {
                type: "warning"
            }).then(() => {
                deleteTag(id).then(resp => {
                    if (resp?.data?.status === 0) {
                        this.$message.success("删除成功");
                        this.loadTagTree();
                    } else {
                        this.$message.error("删除失败：" + (resp?.data?.msg || "接口异常"));
                    }
                }).catch(err => {
                    this.$message.error("删除失败：" + err.message);
                });
            }).catch(() => {
                this.$message.info("已取消删除");
            });
        }
    }
};
</script>

<style scoped>
/* 关键：完全移除之前覆盖 el-tree 原生布局的样式，恢复缩进 */
.tag-tree-node {
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: space-between;
}

.tag-info-left {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
}

/* 新增：icon样式 */
.tag-icon {
    width: 30px;
    height: 30px;
    border-radius: 4px;
    object-fit: cover;
}

.tag-info-right {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
    justify-content: flex-end;
    flex-shrink: 0;
}

.tag-hidden {
    color: #f56c6c;
    background: #fef0f0;
    padding: 2px 6px;
    border-radius: 3px;
}

.tag-name.highlight-text {
    font-weight: bold;
    color: #1890ff;
    font-size: 14px;
    min-width: 80px;
}

.tag-desc {
    font-size: 12px;
    color: #999;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.tag-prop {
    font-size: 12px;
    color: #666;
    min-width: 180px;
}

.tag-actions {
    display: flex;
    gap: 8px;
    flex-shrink: 0;
}

/* 新增：上传样式 */
.avatar-uploader {
    .upload-box {
        width: 120px;
        height: 120px;
        border: 1px dashed #dcdfe6;
        border-radius: 8px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        transition: all 0.3s;

        &:hover {
            border-color: #409eff;
            background-color: #f8f9fa;
        }

        .upload-img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 8px;
        }

        .upload-placeholder {
            display: flex;
            flex-direction: column;
            align-items: center;
            color: #909399;

            i {
                font-size: 24px;
                margin-bottom: 5px;
            }

            span {
                font-size: 12px;
            }
        }
    }
}

::v-deep .el-tree-node.is-current > .el-tree-node__content {
    background-color: #e6f7ff !important;
    color: #1890ff;
}
::v-deep .el-select .el-input__inner {
    cursor: pointer;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}
::v-deep .el-select .el-input__suffix-inner {
    pointer-events: none;
}
</style>